import React from "react";
import { Button } from "nq-component";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import BaseListPage from "../../../../base/BaseListPage";
import CardView from "../../../../components/common/CardView";
import { FloatingForm } from "../../../../components/common/Converter";
import LogoHeader from "../../../../components/common/LogoHeader";
import GeneratePayrollPresenter from "../GeneratePayrollPresenter";
import { parseTime } from "../../../../components/common/Converter";
import PayrollTablePage from "./payroll-table/PayrollTablePage";
import "../../../../components/common/TablePayrollForm.css";
import { Skeleton } from "antd";
import Queue from "nq";
import PayrollFormPresenter from "./PayrollFormPresenter";
import BaseFormPage from "../../../../base/BaseFormPage";
import Progress from "../../../../components/Progress";
export default class PayrollFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.presenter = new PayrollFormPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );

    this.state = {
      objects: [],
      count: 0,
      deductions: [],
      deductionsType: [],
      incentivesType: [],
      deductedTime: [],
      employeesList: [],
      dedutedDays: [],
      isLoading: true,
      absences: [],
      counts: [],
      holidaysCount: 0,
      workingDaysCount: 0,
      weekEndsOff: 0,
      resultObject: [],
      airportAssignDays: {},
    };
  }

  async componentDidMount() {
    const { payrollType } = this.props;
    let deductions = [];
    let incentives = [];
    let attendance = [];
    let employees = [];
    let deducDays = [];

    try {
      [deductions, incentives, attendance, employees, deducDays] =
        await Promise.all([
          findObjectUseCase().execute("other_deductions"),
          findObjectUseCase().execute("incentive"),
          findObjectUseCase().execute("daily_time_record"),
          findObjectUseCase().execute("employees"),
          findObjectUseCase().execute("generate_payroll"),
        ]);
    } catch (error) {
      console.error("An error occurred while fetching data:", error);
    }

    const lateUndertimeMins = await this.presenter.getMinsDeducted();
    if (payrollType === "Augmentation Pay") {
      const personelAirport = await this.presenter.getAssignAirport();
    }
    const resultObject = Object.fromEntries(
      lateUndertimeMins.map(({ employeeId, totalDeductedMins }) => [
        employeeId,
        totalDeductedMins,
      ])
    );

    this.setState({
      deductionsType: deductions,
      incentivesType: incentives,
      deductedTime: attendance,
      employeesList: employees,
      dedutedDays: deducDays,
      incentives,
      resultObject,
    });
    this.presenter.getFetchData();
  }

  getCollectionName() {
    return "generate_payroll";
  }

  sanitizeInput = (input) => {
    return input.replace(/</g, "&lt;").replace(/>/g, "&gt;");
  };

  handleTimeDifference = (params) => {
    return this.presenter.getTimeDifference(params);
  };
  hanldeDeductedInRange = (params) => {
    return this.presenter.getDeductedInRange(params);
  };
  handleImageLoad = () => {
    this.setState({ isLoading: false });
  };

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const {
      deductionsType,
      incentivesType,
      deductedTime,
      dedutedDays,
      absences,
      counts,
      holidaysCount,
      workingDaysCount,
      weekEndsOff,
      resultObject,
      airportAssignDays,
    } = this.state;

    const {
      additionalSelectValue,
      objects1,
      employmentType,
      payrollType,
      csvData,
      startDate,
      endDate,
      leaveType,
      closeAccess,
      refetchData,
      employeeID,
      payrollCode,
      selected,
    } = this.props;

    const start = new Date(startDate);
    const end = new Date(endDate);

    const currentTime = new Date();
    currentTime.setSeconds(0, 0);
    const currentDay = new Date().toLocaleString("en-us", { weekday: "long" });

    const minsDeductedList = deductedTime.map((entry) => {
      const employee = objects1.find((emp) => emp.id === entry.employee.id);
      const scheduleForToday = employee?.schedule?.find(
        (sch) => sch.day === currentDay
      );

      const timeInForToday = scheduleForToday?.timein || "0";
      const timeOutForToday = scheduleForToday?.timeout || "0";

      const hasHoliday =
        entry.timeRecStats &&
        entry.timeRecStats.some((stat) =>
          stat.toLowerCase().includes("holiday")
        );

      const hasLeaves =
        entry.timeRecStats &&
        entry.timeRecStats.some((stat) =>
          leaveType.some((leave) =>
            stat.toLowerCase().includes(leave.toLowerCase())
          )
        );

      const hasSuspension =
        entry.timeRecStats &&
        entry.timeRecStats.some((stat) =>
          stat.toLowerCase().includes("suspended")
        );
      if (hasSuspension) {
      }
      if (hasHoliday || hasLeaves) {
        return {
          id: entry.employee.id,
          date: entry.date,
          minsLate: 0,
          minsUndertime: 0,
          totalMinsDeducted: 0,
          totalDaysDeducted: 0,
        };
      }

      let minsLate = 0;
      let minsUndertime = 0;
      let totalDaysDeducted = 0;

      if (entry.timeIn !== "--:--" && timeInForToday !== "0") {
        minsLate = Math.max(
          this.handleTimeDifference({
            timeStr1: entry.timeIn,
            timeStr2: timeInForToday,
          }),
          0
        );
      }

      if (entry.timeOut !== "--:--" && timeOutForToday !== "0") {
        const timeOutDiff = this.handleTimeDifference({
          timeStr1: timeOutForToday,
          timeStr2: entry.timeOut,
        });
        minsUndertime = timeOutDiff > 0 ? timeOutDiff : 0;
      }
      const totalMinsDeducted = minsLate + minsUndertime;

      return {
        id: entry.employee.id,
        date: entry.date,
        timeIn: entry.timeIn,
        timeOut: entry.timeOut,
        minsLate,
        minsUndertime,
        totalMinsDeducted,
        totalDaysDeducted,
      };
    });

    const employeesMins = minsDeductedList.filter((item) =>
      objects1.some((deducted) => deducted.id === item.id)
    );

    const result = this.hanldeDeductedInRange({
      employeesMins,
      startDate: start,
      endDate: end,
    });
    const resultArray = Object.entries(result).map(([id, data]) => ({
      id,
      ...data,
    }));
    const employeesDeduction = [...resultArray];

    // const employment = employmentType.name;
    const otherDeduction = deductionsType.filter(
      (item) => item.employmentType === additionalSelectValue
    );

    const allowances = incentivesType.filter(
      (item) => item.allowanceType === additionalSelectValue
    );

    if (!schema) return <Progress />;

    return (
      <>
        <FloatingForm width="100%">
          <CardView style={{ padding: 0 }}>
            <h3 className="p-2">Generate Payroll</h3>
            <hr></hr>
            <div className="d-flex justify-content-center flex-column align-items-center flex-md-row  p-2">
              <LogoHeader
                logoSrc={"/BIR.png"}
                altText="Print Logo"
                mainLabel="Republic Of the Philippines"
                subLabel="BUREAU OF IMMIGRATION"
                description="Patriotism * Integrity * Professionalism"
              />
              <img
                src={"/Bagong-Pilipinas-Logo.png"}
                alt="Logo Header 2"
                style={{
                  maxWidth: "130px",
                  maxHeight: "110px",
                }}
              />
            </div>
            <h5 className="text-center fw-bold">{additionalSelectValue}</h5>
            <p className="text-center  m-0 fw-bold">{payrollCode}</p>
            <p className="text-center  m-0">
              <strong>Payroll For the Period:</strong> {startDate} - {endDate}
            </p>

            <PayrollTablePage
              additionalSelectValue={additionalSelectValue}
              employmentType={employmentType}
              csvData={csvData}
              data={objects1}
              otherDeduction={otherDeduction}
              incentives={allowances}
              employeesMins={employeesDeduction}
              daysToDeduc={dedutedDays}
              closeAccess={closeAccess}
              refetchData={refetchData}
              startDate={startDate}
              endDate={endDate}
              payrollType={payrollType}
              payrollCode={payrollCode}
              absences={absences}
              counts={counts}
              employeeID={employeeID}
              holidaysCount={holidaysCount}
              workingDaysCount={workingDaysCount}
              weekEndsOff={weekEndsOff}
              lateUndertimeMins={resultObject}
              airportAssignDays={airportAssignDays}
              selected={selected}
            />
          </CardView>
        </FloatingForm>
      </>
    );
  }
}
